import React, { useEffect, useState } from "react";
import RequestHandler from "util/RequestHandler";

import {
    Table,
    Empty,
    Popconfirm,
    Col,
    Row,
    Divider,
    Button,
    Drawer,
    InputNumber,
    Form,
    Select
} from "antd";
import {
    EditOutlined,
    DeleteOutlined,
    BarsOutlined,
    PlusOutlined
} from "@ant-design/icons";

const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 8,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 16,
        },
    },
};

const ErpPosTransactionExpiryDateModal = (props) => {
    const [loading, setLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [form] = Form.useForm();
    const [tableData, setTableData] = useState({
        data: [],
        total: 0,
        loading: false,
    });
    const [commissions, setCommissions] = useState({ data: [], loading: true });
    const [addDrawerVisibility, setAddDrawerVisibility] = useState(false);
    const [installmentCount, setInstallmentCount] = useState(12);
    const [isBackPaymentPlans, setIsBackPaymentPlans] = useState(0);

    const GetTenantErpProgram = () => {
        RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
            if (response) {
                debugger
                setIsBackPaymentPlans(response.isBackPaymentPlans);
            }
        });
    };

    useEffect(() => {
        if (addDrawerVisibility) {
            let filter = ''
            // if (tableData.data.length > 0) {
            //     if (!isUpdate)
            //         filter = `?$filter=${tableData.data.map(x => `id ne ${x.posCollectionBankInfoId}`).join(' and ')}&`
            //     else {
            //         let posCollectionBankInfoId = form.getFieldsValue('posCollectionBankInfoId').posCollectionBankInfoId
            //         let list = tableData.data.filter(i => i.posCollectionBankInfoId != posCollectionBankInfoId)
            //         filter = list.length > 0 ? `?$filter=${list.map(x => `id ne ${x.posCollectionBankInfoId}`).join(' and ')}&` : ''
            //     }
            // }
            RequestHandler.get(
                `/PosCollectionCommissionDefinition/ExpiryDateNotAddBankInfos${filter == '' ? '?' : filter}$select=id,name,bankName,bankId`
            ).then((response) => {
                setCommissions({
                    data: response,
                    loading: false,
                });
            });
        }
    }, [addDrawerVisibility]);

    useEffect(() => {
        getPosCollectionCommissionDefinitionList();
        GetTenantErpProgram();
    }, []);

    const getPosCollectionCommissionDefinitionList = () => {
        setTableData({
            ...tableData,
            loading: true,
        });
        RequestHandler.get(
            `/BankExpiryDate?$count=true`
        ).then((response) => {
            setTableData({
                data: response.value,
                total: response["@odata.count"],
                loading: false,
            });
        });
    };

    const handleOnClickDelete = (id) => {
        RequestHandler.delete(`/BankExpiryDate/${id}`, null, false).then((response) => {
            setLoading(false);
            if (response.success)
                onAddSuccess();
        });
    };
    const handleOnClickUpdate = (data) => {
        setAddDrawerVisibility(true);
        setIsUpdate(true)
        setInstallmentCount(isBackPaymentPlans ? data.installmentCount: 12)
        form.setFieldsValue({
            id: data.id,
            installmentCount: data.installmentCount,
            installmentExpiryDate1: data.installmentExpiryDate1,
            installmentExpiryDate2: data.installmentExpiryDate2,
            installmentExpiryDate3: data.installmentExpiryDate3,
            installmentExpiryDate4: data.installmentExpiryDate4,
            installmentExpiryDate5: data.installmentExpiryDate5,
            installmentExpiryDate6: data.installmentExpiryDate6,
            installmentExpiryDate7: data.installmentExpiryDate7,
            installmentExpiryDate8: data.installmentExpiryDate8,
            installmentExpiryDate9: data.installmentExpiryDate9,
            installmentExpiryDate10: data.installmentExpiryDate10,
            installmentExpiryDate11: data.installmentExpiryDate11,
            installmentExpiryDate12: data.installmentExpiryDate12,
            posCollectionBankInfoId: data.posCollectionBankInfoId,
        });
    }

    const onAddSuccess = () => {
        form.resetFields();
        getPosCollectionCommissionDefinitionList();
        setAddDrawerVisibility(false);
        setIsUpdate(false)
    };

    const columns = [
        {
            title: "Banka",
            dataIndex: "bankName",
        },
        {
            title: "Tanımlama Adı",
            dataIndex: "name",
        },
        ...(isBackPaymentPlans ? [
            {
                title: "Taksit Sayısı",
                dataIndex: "installmentCount",
            }] : []),
        {
            title: "1. Taksit",
            dataIndex: "installmentExpiryDate1",
        },
        {
            title: "2. Taksit",
            dataIndex: "installmentExpiryDate2",
        },
        {
            title: "3. Taksit",
            dataIndex: "installmentExpiryDate3",
        },
        {
            title: "4. Taksit",
            dataIndex: "installmentExpiryDate4",
        },
        {
            title: "5. Taksit",
            dataIndex: "installmentExpiryDate5",
        },
        {
            title: "6. Taksit",
            dataIndex: "installmentExpiryDate6",
        },
        {
            title: "7. Taksit",
            dataIndex: "installmentExpiryDate7",
        },
        {
            title: "8. Taksit",
            dataIndex: "installmentExpiryDate8",
        },
        {
            title: "9. Taksit",
            dataIndex: "installmentExpiryDate9",
        },
        {
            title: "10. Taksit",
            dataIndex: "installmentExpiryDate10",
        },
        {
            title: "11. Taksit",
            dataIndex: "installmentExpiryDate11",
        },
        {
            title: "12. Taksit",
            dataIndex: "installmentExpiryDate12",
        },
        {
            title: "Düzenle",
            dataIndex: "id",
            width: "1%",
            align: "center",
            render: (data, row) => (
                <a onClick={() => handleOnClickUpdate(row)}>
                    <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
                </a>
            ),
        },
        {
            title: "Sil",
            dataIndex: "id",
            width: "1%",
            align: "center",
            render: (data) => (
                <Popconfirm
                    title="Silmek istiyor musunuz?"
                    okText="Evet"
                    cancelText="Hayır"
                    onConfirm={() => handleOnClickDelete(data)}
                >
                    <a>
                        <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
                    </a>
                </Popconfirm>
            ),
        },
    ];

    const onFinish = (values) => {
        if (isUpdate)
            RequestHandler.put(`/BankExpiryDate`, values).then((response) => {
                setLoading(false);
                if (response.success)
                    onAddSuccess();
            });
        else
            RequestHandler.post(`/BankExpiryDate`, values).then((response) => {
                setLoading(false);
                if (response.success)
                    onAddSuccess();
            });
    };
    const onFinishFailed = (errorInfo) => {
        setLoading(false);
    };

    const handleInstallmentChange = (value) => {
        setInstallmentCount(value || 0); // Değer boş olursa 0 yap
    };

    return (
        <>
            <Row
                id="titleArea"
                justify="space-between"
                align="middle"
                style={{ height: 50 }}
            >
                <Col span={21}>
                    <h1 style={{ marginBottom: 0 }}>
                        <BarsOutlined />  Vade Günleri
                    </h1>
                </Col>
                <Col span={3}>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                            setAddDrawerVisibility(true);
                        }}
                        style={{ marginBottom: 0 }}
                    >
                        <PlusOutlined /> Vade Günü Ekle
                    </Button>
                </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />

            <Row id="tableArea" style={{ minHeight: 400 }}>
                <Col span={24} >
                    <Table
                        columns={columns}
                        locale={{
                            emptyText: (
                                <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description="Veri Yok"
                                />
                            ),
                        }}
                        style={{ overflowX: "auto", minHeight: 500, maxHeight: "100%", width: "100%" }}
                        rowKey="id"
                        filterable={true}
                        sortable={true}
                        pageable={true}
                        dataSource={tableData.data}
                        loading={tableData.loading}
                        size="small"
                    />
                </Col>
            </Row>

            <Drawer
                id="addPosCollectionCommissionDefinitionDrawer"
                title={isUpdate ? "Vade Günü Güncelle" : "Vade Günü Ekle"}
                width={500}
                onClose={() => {
                    setIsUpdate(false);
                    setAddDrawerVisibility(false);
                    form.resetFields();
                }}
                visible={addDrawerVisibility}
                getContainer={false}
                style={{ position: "absolute" }}
            >
                <Form
                    {...formItemLayout}
                    form={form}
                    name="ExpiryDateAdd"
                    initialValues={{
                        remember: true,
                    }}
                    style={{ padding: 50 }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item
                        name="id"
                        hidden
                    >
                    </Form.Item>
                    <Form.Item
                        name="posCollectionBankInfoId"
                        label="Banka"
                        rules={[{ required: true }]}
                    >
                        <Select
                            loading={commissions.loading}
                            filterOption={(input, option) =>
                                option.children
                                    .toLocaleLowerCase("tr-TR")
                                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                            }
                        >
                            {commissions.data.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                    {`${item.bankName} ${item.name ? `- ${item.name}` : ""}`}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {(isBackPaymentPlans) && <Form.Item
                        label={`Taksit Sayısı`}
                        name={`installmentCount`}
                    >
                        <InputNumber min={0} max={12} style={{ width: '100%' }} onChange={handleInstallmentChange} />
                    </Form.Item>}
                    {Array.from({ length: installmentCount }, (_, index) => (
                        <Form.Item
                            key={index}
                            label={`${index + 1}. Taksit`}
                            name={`installmentExpiryDate${index + 1}`}
                        >
                            <InputNumber min={0} style={{ width: '100%' }} />
                        </Form.Item>
                    ))}
                    <Col style={{ textAlign: "right" }}>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            htmlType="submit"
                            onClick={() => setLoading(true)}
                            loading={loading}
                        >
                            {isUpdate ? "Güncelle" : "Ekle"}
                        </Button>
                    </Col>
                </Form>
            </Drawer>
        </>
    );
};

export default ErpPosTransactionExpiryDateModal;
